import Vue from 'vue'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vuetify, { VLayout }  from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import VuetifyConfirm from 'vuetify-confirm'
import i18n from './vuei18n'

Vue.use(Vuetify, {
  iconfont: 'mdi',
  components: {
    VLayout
  }
})

Vue.use(VuetifyConfirm, {
  buttonTrueText: i18n.t('base.ok'),
  buttonFalseText: i18n.t('base.cancel'),
  title: i18n.t('base.confirmation'),
  width: 500,
  property: '$confirm'
})
